export const APIURL = process.env.VUE_APP_APIURL;
export const ENV = process.env.NODE_ENV;
export const MSAL_CLIENT = process.env.VUE_APP_MSAL_CLIENT;
export const MSAL_AUTHORITY = process.env.VUE_APP_MSAL_AUTHORITY;
export const MSAL_REDIRECTURI = process.env.VUE_APP_REDIRECTURI;
export const APPINSIGHT = process.env.VUE_APP_APPINSIGHT || null;
